module.exports = __webpack_public_path__ + "img/bannerLabel2Red.bdc4fb97.png";